export const environment = {
  production: true,
  customemailValidationRegex:
    /^[^<>()[\]\\,;:%#^\s"$&!@]+@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/,
  customphoneValidationRegex: /^07[2-9][0-9]{7}$/,
  authServiceUrl: 'https://hub-keycloak.demo.irembolabs.com',
  authRealm: 'irembo',
  authClientId: 'administration-management-portal',
  authSuccessRedirectUrl: 'https://admin-portal.demo.irembolabs.com',
  apiGatewayBaseUrl: 'https://admin-gateway.demo.irembolabs.com',
  idleTimeOutDuration: 1800,
  idleTimeOutCountDown: 30,
  enableKeycloakMockService: false,
  personNameRegex: /^[^`~!@#$%^&*()\-_=+[\]{}|\\:;'",.<>?/]*$/,
  translationSourceUrl: 'https://admin-gateway.demo.irembolabs.com',
  AESEncryptionKey: 'encryptionKey',
  isDocumentScanningEnabled: true,
};
